// src/api/account.ts
import api from "./client";

// ✅ Define interface for update payload
export interface AccountUpdatePayload {
  address: string;
  phone: string;
  email: string;
  description: string;
  timezone: string;
  operating_hours?: Record<
    string,
    { open: string | null; close: string | null } | null
  >;
}

/**
 * Fetch account details.
 * Token is automatically injected by api/client.ts interceptor.
 */
export const getAccountDetails = async () => {
  try {
    const response = await api.get("/manageAccounts");
    return response.data; // includes timezone
  } catch (error) {
    console.error("🚨 Error fetching account details:", error);
    throw error;
  }
};

/**
 * Update account details including timezone.
 */
export const updateAccountDetails = async (updatedData: AccountUpdatePayload) => {
  try {
    console.log("📡 Sending update request:", updatedData);

    const response = await api.post("/manageAccounts", updatedData);

    console.log("✅ Response from backend:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error updating account:", error);
    throw error;
  }
};

/**
 * Check if a business slug is available.
 */
export const checkSlugAvailability = async (slug: string): Promise<{
  available: boolean;
  suggestion?: string;
}> => {
  if (!slug) {
    return { available: false };
  }

  try {
    const res = await api.get("/checkBusinessSlug", {
      params: { slug },
    });

    return res.data; // expected: { available: true } or { available: false, suggestion: "..." }
  } catch (err) {
    console.error("🚨 Failed to check slug availability:", err);
    return { available: false };
  }
};
